import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DefaultTabs from 'components/tab/DefaultTabs';

import { IProject } from 'utils/types/storyTypes';
import CharactersTable from './CharactersTable';
import ModelTable from '../resource/model/ModelTable';
import CostumeTable from '../resource/costume/CostumeTable';
import NameTagTable from '../resource/nametag/NameTagTable';
import EmoticonTable from '../resource/emoticon/EmoticonTable';

interface IProps {
  currentProject: IProject;
  refreshCounter: number;
}

// * 작품관리 - 리소스 상위 탭
const CharactersMainPage: React.FC<IProps> = ({
  currentProject,
  refreshCounter,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { projectId } = useParams();

  const location = useLocation();
  const characterTabKey = location.state?.characterTabKey || 'character';

  useEffect(() => {
    onClickTab(characterTabKey);
  }, [refreshCounter]);

  // * 탭 클릭 이벤트
  const onClickTab = (activeKey) => {
    const url = `/story/${projectId}/character/${activeKey}`;
    console.log(url);
    navigate(url, {
      state: {
        characterTabKey: activeKey,
        tabKey: 'character',
      },
    });
  };

  /// 작품 관리 내부 탭 메뉴 리스트
  const ResourceTabMenuList = [
    {
      key: 'character',
      tab: '인물',
      table: <CharactersTable selectProject={currentProject} />,
    },
    {
      key: 'model',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.character',
      ),
      table: <ModelTable currentProject={currentProject} />,
    },
    {
      key: 'emoticon',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.emoticon',
      ),
      table: <EmoticonTable selectProject={currentProject} />,
    },
    {
      key: 'costume',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.costume',
      ),
      table: <CostumeTable currentProject={currentProject} />,
    },
    {
      key: 'nametag',
      tab: t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.nameTag',
      ),
      table: <NameTagTable selectProject={currentProject} />,
    },
  ];

  return (
    <DefaultTabs
      type='line'
      onChange={onClickTab}
      activeKey={characterTabKey ? characterTabKey : 'character'}
    >
      {ResourceTabMenuList.map((v) => (
        <Tabs.TabPane key={v.key} tab={v.tab}>
          {v.table}
        </Tabs.TabPane>
      ))}
    </DefaultTabs>
  );
};

export default CharactersMainPage;
